<template>
  <v-container class="d-flex flex-column ga-3">
    <v-row>
      <v-col>
        <UsageExample v-model="tab" :code="code" :tabs="tabs">
          <div class="wrapper">
            <v-container>
              <v-row>
                <div class="grid-container">
                  <div class="sectionTitle">Avatar Types</div>
                  <div class="sectionTitle">Examples</div>
                </div>

                <div class="grid-container">
                  <div>Default (Initial)</div>
                  <div class="d-flex flex-row gap-4 align-center">
                    <hx-avatar
                      size="small"
                      type="initial"
                      initials="AB"
                      name="Alice Border"
                      :generate-color="false"
                    />
                    <hx-avatar
                      type="initial"
                      initials="CD"
                      name="Charlie Davidson"
                      :generate-color="false"
                    />
                    <hx-avatar
                      size="large"
                      type="initial"
                      initials="EF"
                      name="Eve Foster"
                      :generate-color="false"
                    />
                    <hx-avatar
                      size="extra-large"
                      type="initial"
                      initials="GH"
                      name="George Harris"
                      :generate-color="false"
                    />
                  </div>
                </div>

                <div class="grid-container">
                  <div>With 3-Character Initials</div>
                  <div class="d-flex flex-row gap-4 align-center">
                    <hx-avatar
                      size="small"
                      type="initial"
                      name="Alice Border Charlie"
                      :generate-color="false"
                    />
                    <hx-avatar
                      type="initial"
                      initials="DEF"
                      name="Davidson Eve Foster"
                      :generate-color="false"
                    />
                    <hx-avatar
                      size="large"
                      type="initial"
                      initials="GHI"
                      name="George Harris Ivy"
                      :generate-color="false"
                    />
                    <hx-avatar
                      size="extra-large"
                      type="initial"
                      initials="JKL"
                      name="Jack Key Lee"
                      :generate-color="false"
                    />
                  </div>
                </div>

                <div class="grid-container">
                  <div>2-Character Auto-Generated Colors</div>
                  <div class="d-flex flex-row gap-4">
                    <hx-avatar type="initial" initials="AB" name="Alice Border" />
                    <hx-avatar type="initial" initials="CD" name="Charlie Davidson" />
                    <hx-avatar type="initial" initials="EF" name="Eve Foster" />
                    <hx-avatar type="initial" initials="GH" name="George Harris" />
                    <hx-avatar type="initial" initials="IJ" name="Ivy June" />
                  </div>
                </div>

                <div class="grid-container">
                  <div>3-Character Auto-Generated Colors</div>
                  <div class="d-flex flex-row gap-4">
                    <hx-avatar
                      type="initial"
                      size="large"
                      initials="ABC"
                      name="Alice Border Charlie"
                    />
                    <hx-avatar
                      type="initial"
                      size="large"
                      initials="DEF"
                      name="Davidson Eve Foster"
                    />
                    <hx-avatar
                      type="initial"
                      size="large"
                      initials="GHI"
                      name="George Harris Ivy"
                    />
                    <hx-avatar type="initial" size="large" initials="JKL" name="Jack Key Lee" />
                    <hx-avatar
                      type="initial"
                      size="large"
                      initials="MNO"
                      name="Mickey Name Oliver"
                    />
                  </div>
                </div>

                <div class="grid-container">
                  <div>With Image</div>
                  <div class="d-flex flex-row gap-4 align-center">
                    <hx-avatar
                      size="small"
                      type="image"
                      image="https://randomuser.me/api/portraits/women/81.jpg"
                      alt="Woman avatar"
                      name="Alice Border"
                    />
                    <hx-avatar
                      type="image"
                      image="https://randomuser.me/api/portraits/men/32.jpg"
                      alt="Man avatar"
                      name="Charlie Davidson"
                    />
                    <hx-avatar
                      size="large"
                      type="image"
                      image="https://randomuser.me/api/portraits/women/44.jpg"
                      alt="Woman avatar"
                      name="Eve Foster"
                    />
                    <hx-avatar
                      size="extra-large"
                      type="image"
                      image="https://randomuser.me/api/portraits/men/85.jpg"
                      alt="Man avatar"
                      name="George Harris"
                    />
                  </div>
                </div>

                <div class="grid-container">
                  <div>Custom Tooltips</div>
                  <div class="d-flex flex-row gap-4 align-center">
                    <hx-avatar
                      type="initial"
                      initials="AB"
                      name="Alice Border"
                      tooltip-text="Product Designer"
                      :generate-color="false"
                    />
                    <hx-avatar
                      type="initial"
                      initials="CD"
                      name="Charlie Davidson"
                      tooltip-text="Team Lead (On vacation)"
                      :generate-color="false"
                    />
                    <hx-avatar
                      type="image"
                      image="https://randomuser.me/api/portraits/women/44.jpg"
                      alt="Woman avatar"
                      name="Eve Foster"
                      tooltip-text="Click to view profile"
                    />
                    <hx-avatar
                      type="image"
                      image="https://randomuser.me/api/portraits/men/85.jpg"
                      alt="Man avatar"
                      name="George Harris"
                      tooltip-text="Role: Developer"
                    />
                  </div>
                </div>
              </v-row>
            </v-container>

            <v-container>
              <v-row>
                <div class="grid-container">
                  <div class="sectionTitle">Avatar Details Types</div>
                  <div class="sectionTitle">Examples</div>
                </div>

                <v-divider></v-divider>

                <div class="grid-container">
                  <div>Basic Avatar Details</div>
                  <div class="d-flex flex-column gap-4">
                    <hx-avatar :show-details="true" name="Joe Bloggs" :generate-color="false" />

                    <hx-avatar
                      :show-details="true"
                      label="Field label"
                      name="Joe Bloggs"
                      subtitle-text="Subtitle"
                      email-text="joe.bloggs@ideagen.com"
                      type="initial"
                      :chip-props="{ label: 'Active' }"
                      :generate-color="false"
                    />
                  </div>
                </div>

                <v-divider></v-divider>

                <div class="grid-container">
                  <div>With Generated Colors</div>
                  <div class="d-flex flex-column gap-4">
                    <hx-avatar
                      :show-details="true"
                      label="Field label"
                      name="Sarah Johnson"
                      name-text="Custom Text"
                      subtitle-text="Department Manager"
                      email-text="sarah.johnson@ideagen.com"
                      type="initial"
                    />

                    <hx-avatar
                      :show-details="true"
                      name="Tom Williams Custom"
                      name-text="Custom Name & Initial"
                      subtitle-text="Custom subtitle"
                      type="initial"
                      initials="C"
                      tooltip-text="Custom tooltip"
                      :chip-props="{ label: 'Away', color: 'yellow' }"
                    />
                  </div>
                </div>

                <v-divider></v-divider>

                <div class="grid-container">
                  <div>With Image</div>
                  <div class="d-flex flex-column gap-4">
                    <hx-avatar
                      :show-details="true"
                      label="Field label"
                      name="Emma Stone"
                      name-text="Emma Stone"
                      subtitle-text="Designer"
                      email-text="emma.stone@ideagen.com"
                      type="image"
                      image="https://randomuser.me/api/portraits/women/44.jpg"
                      alt="Emma Stone avatar"
                    />

                    <hx-avatar
                      :show-details="true"
                      name="John Smith"
                      name-text="John Smith"
                      subtitle-text="Developer"
                      email-text="john.smith@ideagen.com"
                      type="image"
                      image="https://randomuser.me/api/portraits/men/32.jpg"
                      alt="John Smith avatar"
                      :chip-props="{ label: 'In Meeting', color: 'red' }"
                    />
                  </div>
                </div>
                <v-divider></v-divider>
                <div class="grid-container">
                  <div>Different Sizes</div>
                  <div class="d-flex flex-column gap-4">
                    <hx-avatar
                      :show-details="true"
                      label="Small Avatar"
                      name="Mary Brown"
                      subtitle-text="Avatar background color is based on name, not initials"
                      email-text="MB@ideagen.com"
                      type="initial"
                      size="small"
                      tooltip-text="Avatar background color is based on name"
                    />

                    <hx-avatar
                      :show-details="true"
                      label="Large Avatar"
                      name="Mercedes-Benz"
                      subtitle-text="Product Manager"
                      email-text="mercedes.benz@ideagen.com"
                      type="initial"
                      size="large"
                      :chip-props="{ label: 'Online', color: 'green' }"
                    />

                    <hx-avatar
                      :show-details="true"
                      label="Extra Large Avatar"
                      name="Michael Brown"
                      subtitle-text="CTO"
                      email-text="michael.brown@ideagen.com"
                      type="initial"
                      size="extra-large"
                      initials="MB"
                    />
                  </div>
                </div>
              </v-row>
            </v-container>
          </div>
        </UsageExample>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import UsageExample from '@/components/helix/utils/UsageExample';

export default {
  name: 'HelixAvatars',
  components: { UsageExample },
  setup() {
    const code = `
// Avatar Types
// Default (Initial) with different sizes
<hx-avatar size="small" type="initial" initials="AB" name="Alice Border" :generate-color="false" />
<hx-avatar type="initial" initials="CD" name="Charlie Davidson" :generate-color="false" />
<hx-avatar size="large" type="initial" initials="EF" name="Eve Foster" :generate-color="false" />
<hx-avatar size="extra-large" type="initial" initials="GH" name="George Harris" :generate-color="false" />

// With 3-Character Initials
<hx-avatar size="small" type="initial" name="Alice Border Charlie" :generate-color="false" />
<hx-avatar type="initial" initials="DEF" name="Davidson Eve Foster" :generate-color="false" />
<hx-avatar size="large" type="initial" initials="GHI" name="George Harris Ivy" :generate-color="false" />
<hx-avatar size="extra-large" type="initial" initials="JKL" name="Jack Key Lee" :generate-color="false" />

// 2-Character Auto-Generated Colors
<hx-avatar type="initial" initials="AB" name="Alice Border" />
<hx-avatar type="initial" initials="CD" name="Charlie Davidson" />
<hx-avatar type="initial" initials="EF" name="Eve Foster" />
<hx-avatar type="initial" initials="GH" name="George Harris" />
<hx-avatar type="initial" initials="IJ" name="Ivy June" />

// 3-Character Auto-Generated Colors
<hx-avatar type="initial" size="large" initials="ABC" name="Alice Border Charlie" />
<hx-avatar type="initial" size="large" initials="DEF" name="Davidson Eve Foster" />
<hx-avatar type="initial" size="large" initials="GHI" name="George Harris Ivy" />
<hx-avatar type="initial" size="large" initials="JKL" name="Jack Key Lee" />
<hx-avatar type="initial" size="large" initials="MNO" name="Mickey Name Oliver" />

// With Image
<hx-avatar size="small" type="image" image="https://randomuser.me/api/portraits/women/81.jpg" alt="Woman avatar" name="Alice Border" />
<hx-avatar type="image" image="https://randomuser.me/api/portraits/men/32.jpg" alt="Man avatar" name="Charlie Davidson" />
<hx-avatar size="large" type="image" image="https://randomuser.me/api/portraits/women/44.jpg" alt="Woman avatar" name="Eve Foster" />
<hx-avatar size="extra-large" type="image" image="https://randomuser.me/api/portraits/men/85.jpg" alt="Man avatar" name="George Harris" />

// Custom Tooltips
<hx-avatar type="initial" initials="AB" name="Alice Border" tooltip-text="Product Designer" :generate-color="false" />
<hx-avatar type="initial" initials="CD" name="Charlie Davidson" tooltip-text="Team Lead (On vacation)" :generate-color="false" />
<hx-avatar type="image" image="https://randomuser.me/api/portraits/women/44.jpg" alt="Woman avatar" name="Eve Foster" tooltip-text="Click to view profile" />
<hx-avatar type="image" image="https://randomuser.me/api/portraits/men/85.jpg" alt="Man avatar" name="George Harris" tooltip-text="Role: Developer" />

// Avatar Details Types
// Basic Avatar Details
<hx-avatar :show-details="true" name="Joe Bloggs" :generate-color="false" />
<hx-avatar :show-details="true" label="Field label" name="Joe Bloggs" subtitle-text="Subtitle" email-text="joe.bloggs@ideagen.com" type="initial" :chip-props="{ label: 'Active' }" :generate-color="false" />

// With Generated Colors
<hx-avatar :show-details="true" label="Field label" name="Sarah Johnson" name-text="Custom Text" subtitle-text="Department Manager" email-text="sarah.johnson@ideagen.com" type="initial" />
<hx-avatar :show-details="true" name="Tom Williams" name-text="Tom Williams (Custom Text)" subtitle-text="Custom subtitle" type="initial" initials="C" tooltip-text="Custom tooltip" :chip-props="{ label: 'Away', color: 'yellow' }" />

// With Image
<hx-avatar :show-details="true" label="Field label" name="Emma Stone" name-text="Emma Stone" subtitle-text="Designer" email-text="emma.stone@ideagen.com" type="image" image="https://randomuser.me/api/portraits/women/44.jpg" alt="Emma Stone avatar" />
<hx-avatar :show-details="true" name="John Smith" name-text="John Smith" subtitle-text="Developer" email-text="john.smith@ideagen.com" type="image" image="https://randomuser.me/api/portraits/men/32.jpg" alt="John Smith avatar" :chip-props="{ label: 'In Meeting', color: 'red' }" />

// Different Sizes
<hx-avatar :show-details="true" label="Small Avatar" name="Alex Taylor" subtitle-text="UX Designer" email-text="alex.taylor@ideagen.com" type="initial" size="small" initials="AT" />
<hx-avatar :show-details="true" label="Large Avatar" name="Lisa Cooper" subtitle-text="Product Manager" email-text="lisa.cooper@ideagen.com" type="initial" size="large" initials="LC" :chip-props="{ label: 'Online', color: 'green' }" />
<hx-avatar :show-details="true" label="Extra Large Avatar" name="Michael Brown" subtitle-text="CTO" email-text="michael.brown@ideagen.com" type="initial" size="extra-large" initials="MB" />
    `;

    return {
      code
    };
  },
  data() {
    return {
      tab: 'Avatar Usage',
      tabs: ['Avatar Usage']
    };
  }
};
</script>

<style scoped>
.wrapper {
  background-color: rgb(238, 238, 238);
}

.sectionTitle {
  font-size: 1rem;
  font-weight: 700;
  margin-bottom: 1rem;
  width: 100%;
}

.grid-container {
  width: 100%;
  display: grid;
  grid-template-columns: 1fr 3fr;
  grid-gap: 30px;
  padding: 10px;
  align-items: flex-start;
}

.gap-4 {
  gap: 1rem;
}
</style>
